export function getRandomItem<A>(xs: A[]): A | undefined {
  return xs.length > 0 ? xs[Math.floor(Math.random() * xs.length)] : undefined;
}

/**
 * `min` and `max` are both inclusive
 */
export function getRandomNumber(min: number, max: number): number {
  return Math.floor(Math.random() * (max + 1 - min) + min);
}

export function getRandomPollInterval(base: number) {
  if (base === 0) {
    return 0;
  }

  const min = base / 8;
  const max = base * 2 - min;

  return getRandomNumber(min, max);
}
